<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">日币WriteOff追踪</h3>
      </v-card-title>

      <v-form>
        <v-container fluid>
          <v-layout rowwrap>
            <v-flex xs2>
              <v-text-field clearable label="批次" v-model="query.batchNo"/>
            </v-flex>
            <v-flex xs2>
              <v-text-field clearable label="BuCode" v-model="query.buCode"/>
            </v-flex>
            <v-flex xs2>
              <v-text-field clearable label="Currency" v-model="query.currencyCode"/>
            </v-flex>
            <v-flex xs2>
              <v-text-field clearable label="Napin No" v-model="query.napinNo"/>
            </v-flex>
            <v-flex xs2>
              <v-text-field clearable label="PO No" v-model="query.poNo"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-card-actions>
        <v-btn @click="loadAll">全部</v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10, 20, 50, 100, 200, 500, 1000]"
        :total-items="pagination.totalItems"
        item-key="id"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.batchNo }}</td>
          <td>{{ props.item.batchSeq }}</td>
          <td>{{ props.item.createDate }}</td>
          <td>{{ props.item.status }}</td>
          <td>{{ props.item.buCode }}</td>
          <td>{{ props.item.classification }}</td>
          <td>{{ props.item.currencyCode }}</td>
          <td>{{ props.item.quantity}}</td>
          <td>{{ props.item.unitPrice}}</td>
          <td>{{ props.item.poNo}}</td>
          <td>{{ props.item.amount}}</td>
          <td>{{ props.item.napinNo}}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import qs from 'qs'
export default {
  data() {
    return {
      query: {},
      loading: false,
      status: ['PENDING', 'NORMAL', 'ERROR', 'ABANDON'],
      headers: [
        { text: '批次', value: 'batchNo', sortable: false, width: '120' },
        { text: '序号', value: 'batchSeq', sortable: false, width: '40' },
        {
          text: '创建时间',
          value: 'createDate',
          sortable: false,
          width: '120'
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
          width: '120'
        },
        { text: '事业部', value: 'buCode', sortable: false, width: '40' },
        { text: '貸借区分', value: 'handleFlag', sortable: false, width: '50' },
        {
          text: 'SWIFT通貨コード',
          value: 'currencyCode',
          sortable: false,
          width: '30'
        },
        { text: '数量', value: 'quantity', sortable: false, width: '80' },
        {
          text: '外貨単価',
          value: 'unitPrice',
          sortable: false,
          width: '80'
        },
        {
          text: 'P/O NO.',
          value: 'poNo',
          sortable: false,
          width: '120'
        },
        {
          text: '外貨金額２（海上航空運賃）',
          value: 'amount',
          sortable: false,
          width: '120'
        },
        { text: '送金取引NO.', value: 'napinNo', sortable: false, width: '60' }
      ],
      items: [],
      pagination: {
        rowsPerPage: 10
      }
    }
  },
  methods: {
    loadAll() {
      this.query.type = null
      this.pagination.page = 1
      this.loadData()
    },
    loadPre() {
      this.query.type = 'PRE'
      this.pagination.page = 1
      this.loadData()
    },
    loadFormal() {
      this.query.type = 'FORMAL'
      this.pagination.page = 1
      this.loadData()
    },
    loadData() {
      this.loading = true
      this.$http
        .get(`arap/write-off/jpy`, {
          params: {
            ...this.query,
            page: this.pagination.page - 1,
            size: this.pagination.rowsPerPage,
            sort: ['b2bMeta.batchNo,desc', 'b2bMeta.batchSeq,asc']
          },
          paramsSerializer: params => {
            return qs.stringify(params, { indices: false })
          }
        })
        .then(res => {
          console.log(res.data)
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.items = res.data.content
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  },
  watch: {
    pagination() {
      this.loadData()
    }
  }
}
</script>
